var App = App || {};

App.Login = (function () {
    "use strict";

    let loginButton;
    let loginPanel;
    let focusList = []; // List of focusable elements in the login

    function init() {
        loginButton = document.getElementById('login-button');
        loginPanel = document.getElementById('login');

        // Only add listeners if all required elements are present
        if (loginButton && loginPanel) {
            focusList = loginPanel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
            addEventListeners();
        } else {
            console.warn("One or more required login elements not found. Make sure IDs 'login', 'login-button' exist.");
        }
    }

    /**
     * Initializes all event listeners for the login module.
     * This method is called once the DOM content is loaded.
     */
    function addEventListeners() {
        if (!loginButton || !loginPanel) {
            console.error("Login elements not found. Ensure 'login' and 'login-button' IDs exist.");
            return;
        }

        // Event listener for any link targeting '#login'
        document.querySelectorAll('a[href="#login"]').forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault(); // Prevent default link behavior
                openLogin();
            });
        });

        // Login button click handler
        loginButton.addEventListener('click', e => {
            e.stopPropagation(); // Stop event bubbling to prevent document click from closing immediately
            openLogin();
        });

        // Login container click handler (prevents closing when clicking inside the menu)
        loginPanel.addEventListener('click', e => {
            e.stopPropagation(); // Stop event bubbling
        });

        // Close button click handler
        loginPanel.querySelector('.login__close').addEventListener('click', e => {
            e.stopPropagation(); // Stop event bubbling
            closeLogin();
        });

        // Select change handler for the login form
        loginPanel.querySelector('#login-select').addEventListener('change', e => {
            handleSelectChange(e.target.value); // Handle the change event
        });

        // Document click handler to close the menu if clicking outside
        document.addEventListener('click', (e) => {
            if (login.classList.contains('login--open') && !e.target.closest('#login')) {
                closeLogin();
            }
        });

        // Keyboard navigation listener on the document
        document.addEventListener('keydown', onKeyDown);
    }

    /**
     * Opens the login panel.
     */
    function openLogin() {
        loginPanel.classList.add('login--open');
        loginButton.ariaExpanded = true;
    }

    /**
     * Closes the login panel.
     */
    function closeLogin() {
        loginPanel.classList.remove('login--open');
        loginButton.ariaExpanded = false;
    }
    /**
     * Handles the change event of the login select dropdown.
     * @param {string} selectedOption - The ID of the selected option.
     */
    function handleSelectChange(selectedOption) {
        let options = loginPanel.querySelector('#login-options');

        options.querySelectorAll(':scope > div').forEach((el) => {
            el.classList.add('d-none');
        });

        options.querySelector(`#${selectedOption}`).classList.remove('d-none');
    }

    /**
     * Handles keyboard events for accessibility, specifically for Tab and Escape keys.
     * - Escape key closes the menu.
     * - Tab key traps focus within the menu.
     * @param {KeyboardEvent} e - The keyboard event object.
     */
    function onKeyDown(e) {
        const isTabPressed = e.key === 'Tab';
        const isEscapePressed = e.key === 'Escape';

        // If Escape key is pressed, close the menu
        if (isEscapePressed) {
            closeLogin();
            return;
        }

        // If it's not a Tab key, do nothing
        if (!isTabPressed) {
            return;
        }

        // If Shift + Tab is pressed (moving backward)
        if (e.shiftKey) {
            if (document.activeElement === focusList[0]) {
                focusList[focusList.length - 1].focus(); // Move focus to the last element
                e.preventDefault(); // Prevent default tab behavior
            }
        } else { // If only Tab is pressed (moving forward)
            if (document.activeElement === focusList[focusList.length - 1]) {
                focusList[0].focus(); // Move focus to the first element
                e.preventDefault(); // Prevent default tab behavior
            }
        }
    }

    // Public interface
    return {
        init: init
    };
})();